export default {
      id: "atlas_clinic-usage",
      viewBox: "0 0 80 23",
      url: __webpack_public_path__ + "sprite.svg#atlas_clinic",
      toString: function () {
        return this.url;
      }
    }